import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Orders.css';

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/user/orders`, {
        withCredentials: true
      });
      setOrders(response.data.orders || []);
    } catch (error) {
      console.error('Failed to fetch orders:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (order) => {
    const status = order.paymentStatus || order.orderStatus || 'pending';

    if (status === 'completed' || status === 'confirmed') {
      return <span className="status-badge confirmed">CONFIRMED</span>;
    } else if (status === 'pending') {
      return <span className="status-badge pending">PENDING</span>;
    } else {
      return <span className="status-badge pending">{status.toUpperCase()}</span>;
    }
  };

  if (loading) {
    return <div className="loading">Loading orders...</div>;
  }

  return (
    <div className="orders-page">
      <h1>My Orders</h1>
      <p className="subtitle">View your order history</p>

      {orders.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📦</div>
          <h3>No orders yet</h3>
          <p>Your orders will appear here once you make a purchase</p>
          <a href="/" className="btn-shop">Start Shopping</a>
        </div>
      ) : (
        <div className="orders-list">
          {orders.map((order) => {
            return (
              <div key={order.id} className="order-card">
                <div className="order-header">
                  <div>
                    <span className="order-id">Order #{order.id.slice(0, 8).toUpperCase()}</span>
                    <span className="order-date">
                      {new Date(order.createdAt).toLocaleDateString('en-IN', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                  </div>
                  {getStatusBadge(order)}
                </div>
                
                <div className="order-details">
                  {order.productName && (
                    <div className="detail-row">
                      <span>Product:</span>
                      <strong>{order.productName}</strong>
                    </div>
                  )}
                  {order.items && order.items.length > 0 && !order.productName && (
                    <div className="detail-row items-list">
                      <span>Items:</span>
                      <div className="items-detail">
                        {order.items.map((item, idx) => (
                          <div key={idx} className="item-entry">
                            <strong>{item.name}</strong>
                            {item.quantity > 1 && <span className="item-qty"> × {item.quantity}</span>}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div className="detail-row">
                    <span>Type:</span>
                    <strong>{order.orderType || 'Order'}</strong>
                  </div>
                  <div className="detail-row">
                    <span>Amount:</span>
                    <strong>
                      ₹{order.orderType === 'onetime' 
                        ? (order.totalAmount || order.price || 'N/A') 
                        : (order.price || order.totalAmount || 299)
                      }
                    </strong>
                  </div>
                  <div className="detail-row">
                    <span>Payment:</span>
                    <strong className={`payment-${order.paymentStatus}`}>
                      {order.paymentStatus || 'pending'}
                    </strong>
                  </div>
                </div>
                
                {order.address && (
                  <div className="order-address">
                    <strong>📍 Delivery Address:</strong>
                    <p>{order.address.street}, {order.address.city}, {order.address.state} - {order.address.pincode}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Orders;